import { length } from "../math/vec.ts";
import { Part } from "../skeleton.ts";
import type { FighterState } from "../state.ts";
import { DT, tuning } from "../tuning.ts";

const s = tuning.stamina;

/**
 * Regeneration, exhaustion hysteresis. Strikes and blocks subtract elsewhere.
 * Covering still regenerates, slower: a defender who reads well outlasts an
 * attacker who keeps hitting the guard.
 */
export function updateStamina(f: FighterState, striking: boolean): void {
  if (!striking) {
    const still = length(f.vel) < 0.1;
    let regen = still ? s.regenStill : s.regen;
    if ((f.hp[Part.Torso] ?? 0) < tuning.hp.torso * tuning.hp.injuredBelow) {
      regen *= tuning.injury.torsoRegenFactor;
    }
    if (f.guard || f.checking) regen *= tuning.guard.regenFactor;
    f.stamina += regen * DT;
  }
  if (f.stamina > s.max) f.stamina = s.max;
  if (f.stamina < 0) f.stamina = 0;
  if (f.stamina <= 0) f.exhausted = true;
  else if (f.exhausted && f.stamina >= 20) f.exhausted = false;
}
